class StringService {
    static capitalize(word: string): string {    
        return word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase();
    }

    static getInitial(lastname: string, firstname: string): string {
        return `${firstname.charAt(0).toUpperCase()}${lastname.charAt(0).toUpperCase()}`
    }
}

export default StringService;